import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getBrandFeaturesCorp } from '@ibe.components/corporate/flights/brand/brand';
import { Flight } from '@ibe/models';
import { BookingService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
var CorpBalanceComponent = /** @class */ (function () {
    function CorpBalanceComponent(bookingService, sidebarService, route, router, store) {
        this.bookingService = bookingService;
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.store = store;
        this.isAlive = true;
        this.booking_trip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.booking_steps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.current_step$ = this.store.select(fromStore.getSelectedBookingCurrentStep);
        this.hasChanges$ = combineLatest(this.route.params, this.booking_steps$, this.current_step$, this.booking_trip$);
        this.reviewFlights = false;
        this.timeToThinkFlights = false;
    }
    CorpBalanceComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/review-your-trip'))
            this.reviewFlights = true;
        if (this.router.url.includes('/time-to-think'))
            this.timeToThinkFlights = true;
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var route_params = _a[0], booking_steps = _a[1], current_step = _a[2], booking_trip = _a[3];
            _this.flightIdentifier = route_params.flight;
            _this.booking_trip = booking_trip;
            _this.flight = _this.booking_trip.flights.filter(function (flight) { return flight.id === _this.flightIdentifier; })[0];
            if (route_params.brand)
                _this.brandIdentifier = route_params.brand;
            else
                _this.brandIdentifier = _this.flight.options.brand;
            if (route_params.feature)
                _this.feature = route_params.feature;
            else
                _this.feature = 'corpbalance';
            console.log(getBrandFeaturesCorp(_this.brandIdentifier));
            _this.brand = Object.assign(getBrandFeaturesCorp(_this.brandIdentifier).find(function (cur) { return cur.id == _this.feature; }), { brand: _this.brandIdentifier });
            if (!_this.flight)
                _this.bookingService
                    .getFlight(booking_steps[current_step], route_params.flight, { step: current_step })
                    .pipe(takeWhile(function () { return _this.isAlive; }))
                    .subscribe(function (res) {
                    _this.flight = Object.assign(new Flight(null, null, null), res, { options: { brand: _this.brandIdentifier } });
                }, function (error) { return console.error(error); }, function () { });
        });
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    CorpBalanceComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    CorpBalanceComponent.prototype.TAP_handleClose = function () {
        this.closeSidebar();
    };
    CorpBalanceComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    return CorpBalanceComponent;
}());
export { CorpBalanceComponent };
